import { isArray, isObject } from "./shared/util";

export const logPageLoadCheckpoint = (name: string) => {
  const pageLoadData = (window as any).cuttle_pageLoadData;
  if (isObject(pageLoadData) && isArray(pageLoadData.checkpoints)) {
    pageLoadData.checkpoints.push({ name, time: Date.now() });
  }
};
